export const EMPTY_EXPERIENCE = {
  title: '',
  company: '',
  employmentType: '',
  locationType: '',
  location: '',
  isCurrent: false,
  startMonth: '',
  startYear: '',
  endMonth: '',
  endYear: '',
  description: '',
};

export const EXPERIENCE_LIMITS = {
  TITLE_MAX: 100,
  COMPANY_MAX: 100,
  LOCATION_MAX: 100,
  DESCRIPTION_MAX: 1000,
};

export const EMPLOYMENT_TYPES = {
  FULL_TIME: 'Full-Time',
  PART_TIME: 'Part-Time',
  CONTRACT: 'Contract',
  AGENT: 'Agent',
  TEMPORARY: 'Temporary',
  INTERN: 'Intern',
  VOLUNTEER: 'Volunteer',
};

export const WORK_TYPES = {
  ON_SITE: 'On Site',
  HYBRID: 'Hybrid',
  REMOTE: 'Remote',
};

export const EMPLOYMENT_TYPE_OPTIONS = Object.keys(EMPLOYMENT_TYPES).map((type) => ({
  label: EMPLOYMENT_TYPES[type],
  value: type,
}));

export const WORK_TYPE_OPTIONS = Object.keys(WORK_TYPES).map((type) => ({
  label: WORK_TYPES[type],
  value: type,
}));

export const MONTH_RANGE = {
  MIN: 1,
  MAX: 12,
};

export const DATE_ERROR_MESSAGES = {
  START_MONTH_REQUIRED: 'Start month is required',
  START_YEAR_REQUIRED: 'Start year is required',
  START_IN_FUTURE: 'Start date cannot be in the future',

  END_MONTH_REQUIRED: 'End month is required',
  END_YEAR_REQUIRED: 'End year is required',
  END_IN_FUTURE: 'End date cannot be in the future',
  END_BEFORE_START: 'End date must be after start date',
};

export const MONTH_YEAR_VARIANT = {
  START: 'start',
  END: 'end',
};

export const MONTHS = {
  1: 'January',
  2: 'February',
  3: 'March',
  4: 'April',
  5: 'May',
  6: 'June',
  7: 'July',
  8: 'August',
  9: 'September',
  10: 'October',
  11: 'November',
  12: 'December',
};
